import { getLegalDoc, type LegalDocKind } from '../../content/legal-content';

/**
 * Il corpo di un documento legale. L'HTML arriva dal markdown compilato in fase
 * di build da file versionati nel repo — nessun input di terze parti passa di
 * qui, ed e' il motivo per cui `dangerouslySetInnerHTML` e' accettabile: la
 * sorgente e' il repository, non l'utente.
 */
export default function LegalDocument({ lang, kind }: { lang: string; kind: LegalDocKind }) {
  const doc = getLegalDoc(lang, kind);
  return <div className="legal-content" dangerouslySetInnerHTML={{ __html: doc.html }} />;
}
